import React from 'react'
import {Box} from 'grommet'
import AccountForm from '../../components/accountForm'
import { API,Auth } from 'aws-amplify';
import { NavigationSnackBar,ReturnAddress } from '../../components/utils/shared/shared';

class CreateAddress extends React.Component {

    state = {
        load: false,
        value: {name: '', primary_contact_person: '',primary_contact_email: '', primary_contact_phone: '',address:{AddressLineOne: '', AddressLineTwo: '',AddressLineThree: '',City: '',PostCode: ''}, Country: {CountryCode: ""},owner_id: '', owner_type: ''},
    }
    handleValueChange = (event) => {
        this.setState({value: event});
      };
    handleSubmit = () => {
        this.setState({load: true})
        const address = ReturnAddress(this.state.value, 'address', this.props.user)
        Auth.currentSession().then(session => {
          API
          .post("LabShip", "/addresses",
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{address: address}})
          .then(shipment => {
           this.setState({load: false})
           this.props.history.push({pathname:'/addresses/all', edit:false, addressSucc: true})
         })
        })
      }
    
    render(){
        const {load,value} = this.state;
        return ( 
          <Box>
             <NavigationSnackBar title={'Create Address'} user={this.props.user} pages={[{name: 'Dashboard',link: '/dashboard'},{name: 'Address Book', link: '/addresses/all'}]}  />
              <Box direction='row' alignSelf='center' elevation='medium' round>
                  <AccountForm label={"Create Address"} user={this.props.user} handleSubmit={this.handleSubmit} setAccount={this.handleValueChange} account={value} load={load} />
              </Box>
            </Box>
          )
    }
}

export default CreateAddress
